module.exports = __webpack_public_path__ + "7fef1081e91aa0f753a227a0da564c4b.svg";